import { Directive, ElementRef, HostListener, inject, output } from '@angular/core';

/**
 * Emits when a click occurs outside the host element.
 * Use on dropdown/panel containers to close on outside click.
 */
@Directive({
  selector: '[appClickOutside]',
  standalone: true,
})
export class ClickOutsideDirective {
  private readonly elementRef = inject(ElementRef<HTMLElement>);

  /** Emitted when a click occurs outside the host element. */
  readonly appClickOutside = output<void>();

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as Node;
    const host = this.elementRef.nativeElement;
    if (host.contains(target)) {
      return;
    }
    this.appClickOutside.emit();
  }
}
